import { InAppPreview } from '../previews';
import b64EncodeUnicode from 'cio/utils/base64-unicode';
import { isBlank } from '@ember/utils';
import InAppMessage, { InAppMessageAttribute, MessageDisplay } from 'cio/app-models/in-app/in-app-message';
import { DisplayMode } from 'cio/utils/in-app/message-config';

export function getMessageWithDefaultsForPreview(message: InAppMessage): InAppMessage {
  let messageCopy = InAppMessage.deserialize(message.serialize());
  if (message.isMessageIdPresent) {
    let attributesWithDefault = messageCopy.attributes.map(
      (attr) => new InAppMessageAttribute(attr.key, attr.isBlank ? `$${attr.key}` : attr.value),
    );
    messageCopy.attributes = attributesWithDefault;
  }
  let { display } = messageCopy.config;
  if (display?.mode === DisplayMode.Inline && (display?.value == null || display?.value.length === 0)) {
    messageCopy.configure({
      ...messageCopy.config,
      display: MessageDisplay.inline('$element_id'),
    });
  }
  return messageCopy;
}

export default function hydrateAndEncodeForPreview(data: Record<string, any>) {
  let payload = {
    ...data,
    instanceId: window.UUID.generate(),
    livePreview: true,
    useConfigurationCache: false,
  } as InAppPreview & {
    instanceId: string;
    endpoint: string;
    livePreview: boolean;
    useConfigurationCache: boolean;
  };
  let b64Payload = b64EncodeUnicode(JSON.stringify(payload));
  return encodeURIComponent(b64Payload);
}

export function isInAppRecipientDefined(gistPayload: Record<string, any>) {
  return !isBlank(gistPayload?.userToken);
}

export const DEFAULT_IN_APP_TEMPLATE_BODY = `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">

  <!-- Recommended viewport to ensure in-apps scale properly across devices -->
  <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0">
  <style>
    html {
      overscroll-behavior: none; /* Recommended for mobile use to prevent gestures from moving the in-app off screen */
      cursor: default;
    }

    /* Add custom styles */
  </style>
</head>
<body>
	<!-- Add HTML elements for your in-app message -->
  <!-- Learn more at https://customer.io/docs/journeys/html-in-app-message/ -->
	<h1>Hello In-App World</h1>
	<p>Want to learn more? Check out the <a href="https://customer.io/docs/journeys/html-in-app-message/" onclick="message.dismiss({name: 'in-app-docs'})">In-App Editor HTML guide</a>.</p>
</body>
</html>
`;
